define(["require", "exports", "tslib", "js-cookie"], function (require, exports, tslib_1, js_cookie_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.removeToken = exports.setToken = exports.getToken = exports.setSize = exports.getSize = exports.setLanguage = exports.getLanguage = exports.setSidebarStatus = exports.getSidebarStatus = void 0;
    js_cookie_1 = (0, tslib_1.__importDefault)(js_cookie_1);
    var sidebarStatusKey = 'sidebar_status';
    var getSidebarStatus = function () { return js_cookie_1.default.get(sidebarStatusKey); };
    exports.getSidebarStatus = getSidebarStatus;
    var setSidebarStatus = function (sidebarStatus) { return js_cookie_1.default.set(sidebarStatusKey, sidebarStatus); };
    exports.setSidebarStatus = setSidebarStatus;
    var languageKey = 'language';
    var getLanguage = function () { return js_cookie_1.default.get(languageKey); };
    exports.getLanguage = getLanguage;
    var setLanguage = function (language) { return js_cookie_1.default.set(languageKey, language); };
    exports.setLanguage = setLanguage;
    var sizeKey = 'size';
    var getSize = function () { return js_cookie_1.default.get(sizeKey); };
    exports.getSize = getSize;
    var setSize = function (size) { return js_cookie_1.default.set(sizeKey, size); };
    exports.setSize = setSize;
    var tokenKey = 'vue_typescript_admin_access_token';
    var getToken = function () { return js_cookie_1.default.get(tokenKey); };
    exports.getToken = getToken;
    var setToken = function (token) { return js_cookie_1.default.set(tokenKey, token); };
    exports.setToken = setToken;
    var removeToken = function () { return js_cookie_1.default.remove(tokenKey); };
    exports.removeToken = removeToken;
});
//# sourceMappingURL=UtilsCookies.js.map